import toPLN from "../global/toPLN";
import useRole from "../../hooks/useRole";

export default function StationAllResults({data}) {
    const role = useRole();

    const Score = ({value, ndValue, type, title, after}) => (
        <div className="score">
            <p>{title}</p>
            {type === "cash" ? <h6>{toPLN(value)}</h6> : <h6>{value.toFixed(2)}{after}</h6>}
            <h5 style={ndValue >= 0 ? { color: 'green'} : {color: 'red'} }>{new Number(ndValue).toFixed(2)}%</h5>
        </div>
    );

    return data && (
        <div className="heading-diagrams" style={{margin: '1vh 0'}}>
            <Score value={data.today.total.volume} ndValue={Number(data.compare.volume.percent)} type="num" title="Wolumen paliw" after="l"/>
            <Score value={data.today.total.netto} ndValue={Number(data.compare.netto.percent)} type="cash" title="Sprzedaż netto" after=""/>
            {role !== 'supply' && <Score value={data.today.total.margin} ndValue={Number(data.compare.margin.percent)} type="cash" title="Marża operacyjna" after=""/>}
            <Score value={data.today.total.clients} ndValue={Number(data.compare.clients.percent)} type="num" title="Liczba Klientów" after=""/>
            <Score value={data.today.total.basket} ndValue={Number(data.compare.basket.percent)} type="cash" title="Średni koszyk" after=""/>
        </div>
    )
}
